import { useState, useRef, FC, KeyboardEvent, useEffect } from 'react';
import { CoordinatesType, ProjectType } from '../types/dataTypes';
import styled from 'styled-components';
import tw from 'twin.macro';
import Icon from './Icon';
import { ButtonColor, ButtonSize, IconColor, IconSize, Icons } from '../enums';
import strings from '../language/Swedish';
import Button from './Button';
import useUpdateProjectName from '../api/mutations/useUpdateProjectName';
import useProjects from '../api/queries/useProjects';
import { useProjectContext } from '@/context/ProjectContext';
import { GeocodeItemType, useGeocode } from '@/api/mutations/useGeocode';
const StyledInput = styled.input<{ $isError: boolean }>`
  ${tw`flex-1 py-2 px-8 text-sm border rounded-full`};
  ${({ $isError }) => $isError ? tw`border-red-300` : tw`border-slate-300`};
  &:focus {
    ${tw`ring-emerald-500 border-emerald-500`};
      ${({ $isError }) => $isError ? tw`outline-red-300` : tw`outline-primary`};

  }
`;

const StyledIcon = styled(Icon)`
  ${tw`absolute left-2 rotate-180 scale-x-[-1]`};
`;

const Autocomplete = styled.div`
  ${tw`absolute top-11 bg-white border-slate-300 w-[85%] drop-shadow-xl`};
  z-index: 100;
  border-radius: 10px;
  cursor: pointer;
`;

const Wrapper = styled.div`
${`flex flex-row`}
`;
const Error = styled.div`
text-align:center;
`;

//const AutocompleteInnerWrapper = styled.div`${tw`px-10 py-5 flex flex justify-center`}`


interface Props {
    onPlaceSelected: (coordinates: CoordinatesType) => void;
    project?: ProjectType;
}

const GeocodeInput: FC<Props> = ({ onPlaceSelected, project }) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState(false);
    const { data, isPending, mutate: geocodeMutation } = useGeocode();
    const { refetch: refetchProjects } = useProjects();

    const { setProject } = useProjectContext();

    const { mutate: updateProjectNameMutation } = useUpdateProjectName({
        onSuccess: (data) => {
            refetchProjects();

            setProject((prevState) => ({
                ...prevState,
                name: data.name,
            }));
        },
    });

    const handlePlaceChanged = async () => {
        if (data && data?.results[0]) {
            onPlaceSelected({
                lat: data?.results[0].wgs84lat,
                lng: data?.results[0].wgs84lon,
            });
            setInputValue(data?.results[0].name);
            if (
                project?.id &&
                project?.name === strings.data.noProjectName &&
                data?.results[0].name
            ) {
                updateProjectNameMutation({
                    id: project.id,
                    newName: data?.results[0].name,
                });
            }
        }
    }


    const gotoSearchItem = (item: GeocodeItemType) => {
        if (inputRef.current) {
            setInputValue(item.name);
            onPlaceSelected({ lat: item.wgs84lat, lng: item.wgs84lon })
            handlePlaceChanged();
        }
    };

    function fetch() {
        setError(false);
        geocodeMutation({ query: inputValue, limit: 1 })
    }

    const handleSearchInputKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && inputRef.current) {
            fetch();
        }
    };

    useEffect(() => {
        if (data?.results?.length) {
            if (data?.results[0].name.toLocaleLowerCase() == inputValue.toLocaleLowerCase()) {
                gotoSearchItem(data?.results[0]);
                setError(false);
            }
            else {
                setError(true);
            }
        }
        else if(inputValue.length){
            setError(true);
        }
    }, [data]);

    return (
        <Wrapper>
            <div className="flex flex-row gap-2 items-center">
                <StyledInput
                    $isError={error}
                    ref={inputRef}
                    type="text"
                    value={inputValue}
                    placeholder={strings.data.addAdress}
                    style={{ width: '300px', height: '40px' }}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleSearchInputKeyDown}
                />
                <Autocomplete>
                </Autocomplete>
                <StyledIcon
                    icon={Icons.search}
                    color={IconColor.gray}
                    size={IconSize.medium}
                />
                <Button
                    color={ButtonColor.primary}
                    size={ButtonSize.large}
                    onClick={fetch}>
                    {isPending ? <Icon className="animate-spin" icon={Icons.loading} /> : strings.data.search}
                </Button>
            </div>
            {
                error && (
                    <Error>{strings.data.noHitsFounds}</Error>
                )
            }
            {/* <Autocomplete>
                {!selectedAdress && inputValue.length > 0 && data?.results.length === 1 && data?.results.map((item: GeocodeItemType, index) => {
                    return (<div key={item.name} onClick={() => gotoSearchItem(item)} className={`p-4 hover:bg-gray-100 pointer text-xs truncate ${data?.results.length - 1 !== index && 'border-b border-slate-200'}`}>{item.name}</div>)
                })}
                {isPending && <AutocompleteInnerWrapper><Loading /></AutocompleteInnerWrapper>}
                {!isPending && data?.results.length == 0 && inputValue.length && <AutocompleteInnerWrapper>{strings.data.noHitsFounds}</AutocompleteInnerWrapper>}

            </Autocomplete> */}
        </Wrapper>
    );
};

export default GeocodeInput;
